<template>
  <v-container>
    <form>
      <v-text-field
        label="Name"
        v-model="name"
        :error-messages="nameErrors"
        :counter="10"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
        required
      />
      <v-text-field
        label="E-mail"
        v-model="email"
        :error-messages="emailErrors"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
        required
      />
      <v-select
        label="Item"
        v-model="select"
        :items="items"
        :error-messages="selectErrors"
        @change="$v.select.$touch()"
        @blur="$v.select.$touch()"
        required
      />
      <v-checkbox
        label="Do you agree?"
        v-model="checkbox"
        :error-messages="checkboxErrors"
        @change="$v.checkbox.$touch()"
        @blur="$v.checkbox.$touch()"
        required
      />

      <vue2-dropzone @vdropzone-file-added="vfileAdded"
                     @vdropzone-error="verror"
                     @vdropzone-success="vsuccess"
                     @vdropzone-sending="vsending"
                     @vdropzone-success-multiple="vsuccessMuliple"
                     @vdropzone-sending-multiple="vsendingMuliple"
                     @vdropzone-queue-complete="vqueueComplete"
                     @vdropzone-total-upload-progress="vprogress"
                     @vdropzone-mounted="vmounted"
                     @vdropzone-drop="vddrop"
                     @vdropzone-drag-start="vdstart"
                     @vdropzone-drag-end="vdend"
                     @vdropzone-drag-enter="vdenter"
                     @vdropzone-drag-over="vdover"
                     @vdropzone-drag-leave="vdleave"
                     id="dropzone" :options="dropzoneOptions" destroyDropzone="false"/>

      <v-btn @click="submit">submit</v-btn>
      <v-btn @click="clear">clear</v-btn>
    </form>
  </v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required, maxLength, email } from 'vuelidate/lib/validators';

  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.css';

  export default {
    name: 'upload',
    components: {
      vue2Dropzone
    },
    mixins: [ validationMixin ],
    validations: {
      name: {
        required,
        maxLength: maxLength(10)
      },
      email: {
        required,
        email
      },
      select: {required},
      checkbox: {required}
    },
    data () {
      return {
        name: '',
        email: '',
        select: null,
        items: [
          'Item 1',
          'Item 2',
          'Item 3',
          'Item 4'
        ],
        checkbox: false,
        dropzoneOptions: {
          url: 'http://localhost:5000/addon-manager/us-central1/upload',
          maxFilesize: 2,
          headers: {'My-Awesome-Header': 'header value'},
          addRemoveLinks: true,
          autoProcessQueue: true,
          acceptedFiles: '.zip,image/*,.capx',
          thumbnailMethod: 'contain',
          accept (file, done) {
            console.log(file);
            done();
          },
          resize (file, width, height) {
            console.log("(width / 2) + (file.width / 2)", (width / 2) + (file.width / 2));
            return {
              srcWidth: width,
              srcHeight: height,
              trgWidth: width,
              trgHeight: height,
              srcX: 0,
              srcY: 0,
              trgX: (width / 2) - (file.width / 2),
              trgY: (height / 2) - (file.height / 2),
            };
          }
        }
      };
    },
    methods: {
      submit () {
        this.$v.$touch();
      },
      clear () {
        this.$v.$reset();
        this.name = '';
        this.email = '';
        this.select = null;
        this.checkbox = false;
      },
      vfileAdded () {
        console.log('vfileAdded');
      },
      verror () {
        console.log('verror');
      },
      vsuccess () {
        console.log('vsuccess');
      },
      vsending () {
        console.log('vsending');
      },
      vsuccessMuliple () {
        console.log('vsuccessMuliple');
      },
      vsendingMuliple () {
        console.log('vsendingMuliple');
      },
      vqueueComplete () {
        console.log('vqueueComplete');
      },
      vprogress (totalProgress, totalBytes, totalBytesSent) {
        console.log(Math.floor(totalProgress));
      },
      vmounted () {
        console.log('vmounted');
      },
      vddrop () {
        console.log('vddrop');
      },
      vdstart () {
        console.log('vdstart');
      },
      vdend () {
        console.log('vdend');
      },
      vdenter () {
        console.log('vdenter');
      },
      vdover () {
        console.log('vdover');
      },
      vdleave () {
        console.log('vdleave');
      }
    },
    computed: {
      checkboxErrors () {
        const errors = [];
        if (!this.$v.checkbox.$dirty) {
          return errors;
        }
        !this.$v.checkbox.required && errors.push('You must agree to continue!');
        return errors;
      },
      selectErrors () {
        const errors = [];
        if (!this.$v.select.$dirty) {
          return errors;
        }
        !this.$v.select.required && errors.push('Item is required');
        return errors;
      },
      nameErrors () {
        const errors = [];
        if (!this.$v.name.$dirty) {
          return errors;
        }
        !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
        !this.$v.name.required && errors.push('Name is required.');
        return errors;
      },
      emailErrors () {
        const errors = [];
        if (!this.$v.email.$dirty) {
          return errors;
        }
        !this.$v.email.email && errors.push('Must be valid e-mail');
        !this.$v.email.required && errors.push('E-mail is required');
        return errors;
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Upload.vue